module.exports = __webpack_public_path__ + "static/RootSans-7SemiBold-f5a06a7f60efb2c82c5cf9ae18e9a80f.woff2";